import { ReactNode } from 'react';

import classNames from 'classnames';
import {
  BasicTableDataRow,
  TableCellContentAlignEnum,
  TableDataRow,
  TableHeaderItem,
} from '@employ-engage/data';

export interface TableRowProps<T extends BasicTableDataRow> {
  onClickRow?: (row: T) => void;
  row: TableDataRow<T>;
  headerList: TableHeaderItem[];
  rowActions?: (row: TableDataRow<T>) => ReactNode;
  backgroundColor?: string;
}

export function TableRow<T extends BasicTableDataRow>({
  onClickRow,
  headerList,
  row,
  backgroundColor,
}: TableRowProps<T>) {
  return (
    <tr
      onClick={onClickRow ? () => onClickRow(row) : undefined}
      className={classNames({
        'bg-dark-primary-opacity-60': !backgroundColor,
        [backgroundColor || '']: !!backgroundColor,
        'line-through text-red-700': row.isDeleted,
        'text-neutral-900': !row.isDeleted,
        'cursor-pointer hover:bg-gray-100': !!onClickRow,
      })}
    >
      {headerList.map((li: any, index: number) => {
        return (
          <td
            key={index}
            className={classNames(
              'py-[16.13px] px-[19.72px] text-[13px] font-medium leading-[17.93px] tracking-tight',
              {
                'dark:bg-dark-primaryBackground': !backgroundColor,
                [backgroundColor || '']: !!backgroundColor,
              },
              {
                'text-left':
                  !li.alignment ||
                  li.alignment === TableCellContentAlignEnum.LEFT,
                'text-center':
                  li.alignment === TableCellContentAlignEnum.CENTER,
                'text-right': li.alignment === TableCellContentAlignEnum.RIGHT,
              }
            )}
          >
            {row[li.id] as ReactNode}
          </td>
        );
      })}
    </tr>
  );
}

export default TableRow;
